import React from 'react';
import FormGroup from '@material-ui/core/FormGroup';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import { ConfirmationButton } from "../ConfirmationButton/ConfirmationButton";

import cn from './ActiveAgencyForm.module.scss';

export class ActiveAgencyForm extends React.PureComponent {
  state = {
    selectedAgencyId: '',
  };

  componentDidMount() {
    const { agencies } = this.props;

    if (Array.isArray(agencies)) {
      this.calculateSelected();
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.agencies !== this.props.agencies) {
      this.calculateSelected();
    }
  }

  calculateSelected = () => {
    const { agencies } = this.props;
    let selectedAgencyId = '';

    const active = agencies.filter(agency => agency.isActive);
    if (active.length) {
      selectedAgencyId = active[0].id;
    }

    this.setState({
      selectedAgencyId,
    });
  };

  handleSelect = (event) => {
    this.setState({
      selectedAgencyId: event.target.value,
    })
  };

  handleSubmit = () => {
    this.props.onSubmit({
      selectedAgencyId: this.state.selectedAgencyId,
      type: this.props.type,
    });
  };

  render() {
    const { selectedAgencyId } = this.state;
    const { agencies, onSubmit, type } = this.props;
    return (
      <div>
        <div className={cn.label}>Set active {type} agency</div>
        <Select
            value={selectedAgencyId}
            onChange={this.handleSelect}
        >
          {agencies.map(agency => <MenuItem key={agency.id} value={agency.id}>{agency.name}</MenuItem>)}
        </Select>
        {onSubmit && (
          <FormGroup row classes={{root: cn.saveButton }}>
            <ConfirmationButton
              disabled={!selectedAgencyId}
              onClick={this.handleSubmit}
            />
          </FormGroup>
        )}
      </div>
    );
  }
}
